import { RootState } from './types';

export const selectAuth = (state: RootState) => state.auth;
export const selectTheme = (state: RootState) => state.theme;
export const selectMultiAccount = (state: RootState) => state.multiAccount;
export const selectOrgId = (state: RootState) => state.org.orgId;
export const selectOrg = (state: RootState) => state.org.org;
